import * as types from '@/store/mutation-types';
import RegisterStep1 from '@/components/ruc/Register-step1';
import RegisterStep2 from '@/components/ruc/Register-step2';
import RegisterStep3 from '@/components/ruc/Register-step3';
import TopTools from '@/components/ruc/TopTools';
import RUC from '../utils/Ruc';

export default {
    name: 'Register',
    components: {
        RegisterStep1,
        RegisterStep2,
        RegisterStep3,
        TopTools,
    },
    data() {
        return {
            // -------Spin Mask---------
            spinShow: false,
            // -------Register Info ------
            /**
             * @account address
             * @account mnemonic
             * @account mnemoniccliper
             * @account publickey
             * @account userid
             */
            userInfo: {},
            account: {},
            /**
             * @gtt challenge
             * @gtt gt
             */
            gtt: {},
            // ---------step----------
            step: 1,
            // ---------step1---------
            errData: {
                type: '',
                errmsg: '',
            },
            // ---------step2---------
            mnomenics: [],
            cmnomenics: [],
            // ---------step3---------
            callbackInfo: {},
        };
    },
    computed: {
        webContent() {
            return this.$store.state.webContent;
        },
    },
    mounted() {
        this.initVaildCheck();
        // RegisterFunc.createAccount('yiyang713', 'Lijiaqi1992');
    },
    methods: {
        initVaildCheck() {
            const self = this;
            RUC.vaildCheck().then(self.saveRegisterInfo);
        },
        saveRegisterInfo(res) {
            const self = this;
            self.account = res.account;
            self.gtt = res.data;
            self.handleUserInfo(res.account);
            const baseAccount = res.baseAccount;
            self.getAddress(baseAccount);
        },
        handleUserInfo(a) {
            const self = this;
            const accountInfo = a;
            const mnemoic = accountInfo.mnemonic.split(' ');
            const cmnemoic = accountInfo.mnemonic.split(' ');
            mnemoic.push(self.userInfo.username);
            cmnemoic.push(self.userInfo.username);
            self.mnomenics = mnemoic;
            self.cmnomenics = cmnemoic;
        },
        getAddress(baseAccount) {
            const self = this;
            const userId = baseAccount.userid;
            RUC.getDepositAddress(userId).then((res) => {
                self.address = res.data;
                const accountInfo = Object.assign(baseAccount, res.data);
                self.$store.commit(types.ADD_ACCOUNT, accountInfo);
                self.spinShow = false;
            });
        },
        goToStep2(e, checkInviter) {
            // eslint-disable-next-line no-console
            const self = this;
            self.spinShow = true;
            RUC.createAccount(e.username, e.password, e.repassword, checkInviter)
                .then((res) => {
                    self.userInfo.username = e.username;
                    self.step = 2;
                    self.saveRegisterInfo(res);
                    const { password } = e;
                    this.$store.dispatch('getKycToken', { password, forceUpdate: true, account: res.account });
                })
                .catch((err) => {
                    self.spinShow = false;
                    if (err.code === 403) {
                        self.errData = {
                            type: 'username',
                            errmsg: 'account_username_is_already_exist',
                        };
                        return;
                    }
                    console.log(err, 'err.code === 100003 ', checkInviter);
                    if (err.code === 100003 && checkInviter) {
                        this.$store.commit(types.CHANGE_INVITER_NOT_EXIST, true);
                        return;
                    }
                    this.$store.commit(types.CHANGE_INVITER_NOT_EXIST, false);

                    self.errData = {
                        type: 'username',
                        errmsg: err.msg || 'Error',
                    };
                });
        },
        goToStep3() {
            const self = this;
            self.step = 3;
        },
        backToStep2() {
            const self = this;
            self.cmnomenics = self.mnomenics;
            self.step = 2;
        },
        completeRegister(e) {
            const self = this;
            const oriMno = self.mnomenics;
            if (JSON.stringify(oriMno) === JSON.stringify(e)) {
                self.$router.push('/');
            } else {
                self.callbackInfo = {
                    code: 1,
                    errmsg: self.$t('account_mnomenics_was_incorrect'),
                };
            }
        },
    },
};



// WEBPACK FOOTER //
// ./src/views/register.js